import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

interface LoginRequiredModalProps {
  visible: boolean;
  onHide: () => void;
}

const LoginRequiredModal: React.FC<LoginRequiredModalProps> = ({ visible, onHide }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/loginsebis", { state: { from: window.location.pathname } });
    onHide();
  };

  const footer = (
    <div className="flex justify-content-end gap-2">
      <Button
        label="Bakmaya Devam Et"
        icon="pi pi-eye"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label="Giriş Yap"
        icon="pi pi-sign-in"
        className="p-button-primary"
        onClick={handleLogin}
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Giriş Gerekli"
      className="w-90 md:w-50"
      footer={footer}
      modal
    >
      <div className="flex align-items-center mb-3">
        <i className="pi pi-exclamation-triangle text-orange-600 text-2xl mr-3"></i>
        <div>
          <h3 className="text-lg font-bold mb-2">Anket Doldurmak İçin Giriş Yapın</h3>
          <p className="text-600 mb-3">
            Bu anketi doldurmak için hesabınıza giriş yapmanız gerekmektedir.
          </p>
          <p className="text-sm text-500">
            Giriş yaptıktan sonra anketi doldurabilirsiniz.
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default LoginRequiredModal; 